import { formatCurrency, PNL_COLORS } from "@/lib/trader-format";

interface Props {
  value: number | null | undefined;
  /** Bigger font weight, used in primary columns (e.g. /traders PnL col). */
  bold?: boolean;
  /** Show "+" prefix on positive values. Default true (matches /traders). */
  showPlus?: boolean;
  className?: string;
}

/**
 * Colored PnL display. Green when ≥0, red when <0, dash when null/undefined.
 * Matches the styling used across leaderboard tables.
 */
export default function PnLValue({ value, bold = true, showPlus = true, className = "" }: Props) {
  if (value == null) {
    return (
      <span className={`text-xs font-sans text-gray-400 dark:text-gray-600 ${className}`}>—</span>
    );
  }
  const isProfit = value >= 0;
  const color = isProfit ? PNL_COLORS.profit : PNL_COLORS.loss;
  const weight = bold ? "font-bold" : "font-semibold";
  return (
    <span className={`text-xs font-sans ${weight} ${color} ${className}`}>
      {isProfit && showPlus ? "+" : ""}
      {formatCurrency(value)}
    </span>
  );
}
